import { Component, ElementRef, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { GENERIC_AUTH_SERVICE_TOKEN, GenericAuthService } from '@nk/auth-lib';
import { AppMembershipEntity } from '@nk/data-entities-lib';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'nk-risk-password-reset-link',
  templateUrl: 'risk-password-reset-link.component.html',
  standalone: false,
})
export class RiskPasswordResetLinkComponent implements OnInit {
  @Input() public inputEmail: string;
  @Input() public changePasswordText = extractTranslation('password_reset.change_password_default_text');
  @ViewChild('modalReset') public modalResetTemplate: TemplateRef<ElementRef>;
  @ViewChild('modalSuccess') public modalSuccessTemplate: TemplateRef<ElementRef>;
  @ViewChild('modalError') public modalErrorTemplate: TemplateRef<ElementRef>;
  public membership: AppMembershipEntity;
  public modalRef: BsModalRef;
  public email: string;

  constructor(
    private _modalService: BsModalService,
    @Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService,
  ) {}

  public ngOnInit(): void {
    if (this.inputEmail) {
      this.email = this.inputEmail;
    }
  }

  public onResetPasswordClick(): void {
    this.modalRef = this._modalService.show(this.modalResetTemplate, { class: 'modal-white' });
  }

  public onSubmitPasswordReset(): void {
    const params = {
      connection: 'Username-Password-Authentication',
      email: this.email,
    };
    this._authService.resetPasswordRequest(params, (err) => {
      if (err) {
        this.modalRef = this._modalService.show(this.modalErrorTemplate, { class: 'modal-white' });
      } else {
        this.modalRef = this._modalService.show(this.modalSuccessTemplate, { class: 'modal-white' });
      }
    });
  }
}
